import React from 'react';
import { motion } from 'framer-motion';
export function VisionSection() {
  return <section id="vision" className="pt-10 relative" data-id="element-163">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-164">
        <div className="mb-8 relative" data-id="element-165">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-166">
            MY MISSION
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-6 tracking-tight bg-gradient-to-r from-[#FF0000] via-[#FFDD00] via-[#00DD00] via-[#0088FF] to-[#8800FF] bg-clip-text text-transparent" data-id="element-167">
            COMMUNITY-DRIVEN LEARNING
          </h3>
          <div className="flex gap-2 mt-4 mb-8" data-id="element-168">
            {['#00DD00', '#0088FF', '#8800FF'].map((color, i) => <div key={i} className="h-2 w-20" style={{
            backgroundColor: color
          }} data-id="element-169" />)}
          </div>
        </div>
        <div className="mb-8 space-y-6 text-lg leading-relaxed max-w-3xl" data-id="element-170">
          <p data-id="element-171">
            I want to take learning away from billionaires and make it community
            driven while enabling ethical and stable monetization for the
            community.
          </p>
          <p className="font-bold text-xl" style={{
          color: '#8800FF'
        }} data-id="element-172">
            I want to help regular people turn their creative ideas into income
            and build a life that feels like theirs, not company-issued.
          </p>
        </div>
        <div className="mb-8" data-id="element-173">
          <h3 className="text-2xl font-bold mb-6" data-id="element-174">THE PLAN</h3>
          <div className="grid md:grid-cols-3 gap-4" data-id="element-175">
            {[{
            phase: 'PHASE 1',
            title: 'CREATE',
            desc: 'Daily content. Build community. Reach out to mentors and creators. Build real relationships.',
            timeline: 'MONTHS 1-3',
            color: '#0088FF'
          }, {
            phase: 'PHASE 2',
            title: 'GATHER',
            desc: 'Research what people actually need. Launch Kickstarter. Prove demand. Show ethical monetization works.',
            timeline: 'MONTHS 3-6',
            color: '#8800FF'
          }, {
            phase: 'PHASE 3',
            title: 'BUILD',
            desc: 'Ship MVP with lean team. €250k round. Turn vision into platform.',
            timeline: 'MONTHS 6-12',
            color: '#00DD00'
          }].map((phase, i) => <motion.div key={i} className="border-4 border-black bg-white overflow-hidden" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} data-id="element-176">
                <div className="p-2 text-center font-bold text-sm" style={{
              backgroundColor: phase.color
            }} data-id="element-177">
                  {phase.phase}
                </div>
                <div className="p-5" data-id="element-178">
                  <h4 className="text-lg font-bold mb-2" data-id="element-179">{phase.title}</h4>
                  <p className="text-sm mb-4" data-id="element-180">{phase.desc}</p>
                  <div className="border-t-2 border-black pt-3" data-id="element-181">
                    <div className="text-xs font-bold text-center" data-id="element-182">
                      {phase.timeline}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}